import { useRef } from 'react'
import { motion, useInView } from 'framer-motion'
import { HiStar } from 'react-icons/hi'

interface Testimonial {
  quote: string
  name: string
  role: string
  initials: string
}

const TESTIMONIALS: Testimonial[] = [
  {
    quote: "Finally, a platform that explains the reasoning behind each bet. The transparency is incredible - I can see exactly why a line is suggested and make my own informed decisions.",
    name: "Marcus T.",
    role: "Professional Bettor",
    initials: "MT"
  },
  {
    quote: "The Dixon-Coles model and per-90 stats have completely changed how I approach player props. My hit rate has improved significantly since switching to StatScout.",
    name: "Sarah K.",
    role: "Sports Analyst",
    initials: "SK"
  },
  {
    quote: "I love that it's not just tips - it's actual data. The referee analysis and sample size warnings have saved me from making bad bets more times than I can count.",
    name: "James C.",
    role: "Weekend Bettor",
    initials: "JC"
  }
]

export function TestimonialsSection() {
  const ref = useRef<HTMLElement>(null)
  const isInView = useInView(ref, { once: true, margin: '-100px' })

  return (
    <section ref={ref} className="testimonials-section">
      <div className="testimonials-header">
        <motion.span
          className="testimonials-label"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          Testimonials
        </motion.span>
        <motion.h2
          className="testimonials-title"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Loved by Bettors Worldwide
        </motion.h2>
        <motion.p
          className="testimonials-subtitle"
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          See what our users are saying about StatScout
        </motion.p>
      </div>

      <div className="testimonials-grid">
        {TESTIMONIALS.map((testimonial, index) => (
          <motion.div
            key={testimonial.name}
            className="testimonial-card"
            initial={{ opacity: 0, y: 30 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.5, delay: 0.3 + index * 0.1 }}
            whileHover={{ scale: 1.02 }}
          >
            <div className="testimonial-stars">
              {[...Array(5)].map((_, i) => (
                <HiStar key={i} className="testimonial-star" />
              ))}
            </div>
            <p className="testimonial-quote">"{testimonial.quote}"</p>
            <div className="testimonial-author">
              <div className="testimonial-avatar">{testimonial.initials}</div>
              <div className="testimonial-info">
                <span className="testimonial-name">{testimonial.name}</span>
                <span className="testimonial-role">{testimonial.role}</span>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  )
}
